import { render } from "./IdentificationStatus.vue?vue&type=template&id=34fe800d&scoped=true"
import script from "./IdentificationStatus.vue?vue&type=script&lang=js"
export * from "./IdentificationStatus.vue?vue&type=script&lang=js"

import "./IdentificationStatus.vue?vue&type=style&index=0&id=34fe800d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fe800d"]])

export default __exports__